// import Navbar   from "../../components/c_navbar";
import Menu     from "../../components/Menu/menu.jsx";
// import Busca    from   "../../components/Busca/c_busca.jsx";
// import SideBar from "../../components/Menu/SideBar/c_sidebar.jsx";
import Footer from "../../components/Footer/footer.jsx";



function FaleConosco (){
    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    {/* <Navbar /> */}
                    <Menu page="faleconosco"/>
                    {/* <SideBar/> */}
                </div>
                <div className="col py-3 me-3">
                    {/* <Busca/> */}
                    <h1>Fale Conosco</h1>
                    <hr />
                    <h3>Página em construção...</h3>
                    <hr />

                    <h5>► Acompanhar um chamdo em aberto</h5>
                    <h5>► Denunciar ou reclamar de um prestador</h5>
                    <h5>► Sugerir - Criticar - Elogiar</h5>
                    <h5>► Exclusão da conta</h5>
                </div>
            </div>

        </div>

        <Footer />
    </>
}

export default FaleConosco;